export enum StateEntity {
  User = 'User',
  Setting = 'Setting',
  Conversation = 'Conversation',
  Participant = 'Participant',
  Message = 'Message',
}
